<template>
  <el-container class="container-whole">
    <el-header height="50px">
      <img class="header-logo" src="@/assets/images/home-title.png" />
      <el-button type="warning" size="mini" plain round icon="el-icon-edit" @click="handlerEditPsw" style="right: 90px;">修改密码</el-button>
      <el-button type="danger" size="mini" round icon="el-icon-close" @click="handlerLogout">退出</el-button>
    </el-header>
    <el-container class="container-aside-main">
      <el-aside class="container-aside" :width="asideWidth">
        <div class="el-aside-bg"></div>
        <el-scrollbar wrap-class="scrollbar-wrapper">
          <section class="user-tools-container">
            <div class="user-info">
              <span class="user-icon"><i class="el-icon-user-solid"></i></span>
              <span class="user-name">{{account}}</span>
            </div>
          </section>
          <ezz-side-menu :menus="currentMenus" :activeMenuIndex="activeMenuIndex" :defaultOpeneds="defaultOpeneds" :parent="this" />
        </el-scrollbar>
      </el-aside>
      <el-main class="container-main">
        <div class="layer-current-position">
          <span class="asideIcon" @click="setAsideWidth"><i :class="asideIcon"></i></span>
          <span style="font-weight: bold; margin-left: 5px;"><i class="el-icon-s-flag"></i> 当前位置：{{currentPosition}}</span>
        </div>
        <div class="ezz-tabs-container" style="width: 100%; height: 38px;">
          <el-tabs v-model="$store.state.activeTabName" type="card" @tab-click="handlerTabClick" @tab-remove="handlerTabRemove">
            <!--<el-tab-pane label="控制台" name="dashboard"></el-tab-pane>-->
            <el-tab-pane v-for="item in $store.state.tabs" :key="item.id" :label="item.title" :name="item.name" :closable="item.name !== 'dashboard'"></el-tab-pane>
          </el-tabs>
        </div>
        <keep-alive><router-view :parent="this" /></keep-alive>
      </el-main>
    </el-container>
    <el-dialog :visible="showEditPsw" width="400px" :close-on-click-modal="false" :modal-append-to-body="false" :append-to-body="true" :show-close="false">
      <div slot="title" class="dialog-title-container">
        <span class="title-label"><i class="el-icon-document"></i> 修改密码</span>
        <i class="el-icon-error" @click="handlerClose"></i>
      </div>
      <el-button type="primary" size="mini" plain round icon="em-icon-save" @click="handlerSubmit"> 提交保存</el-button>
      <el-form ref="form" :model="formData" size="mini" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="旧密码">
              <el-input placeholder="旧密码" clearable v-model="formData.oldPsw" show-password></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="新密码">
              <el-input placeholder="新密码" clearable v-model="formData.newPsw" show-password></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="确认新密码">
              <el-input placeholder="确认新密码" clearable v-model="formData.confirmNewPsw" show-password></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <ezz-context-menu ref="contextMenu" :contextMenuTab="contextMenuTab" :contextMenuPosition="contextMenuPosition" :rawMenus="rawMenus"></ezz-context-menu>
  </el-container>
</template>

<script>
import EzzContextMenu from '@/components/ezz-contextmenu/contextmenu.vue'
import EzzSideMenu from '@/components/ezz-sidemenu/sidemenu.vue'
import '@/components/ezz-sidemenu/sidemenu.css'

export default {
  name: 'home',
  data: function () {
    return {
      formData: {
        oldPsw: '',
        newPsw: '',
        confirmNewPsw: '',
        operator_id: sessionStorage.getItem('operator_id')
      },
      // 由于增加了快捷菜单，需要一个数据，接收点击快捷菜单后，获取到的当前菜单集合
      currentMenus: [],
      // 登录后，根据登录者的权限，获取到菜单
      menus: JSON.parse(sessionStorage.getItem('menus')),
      // 数据库中原始数据，没有建立上下级关系，简单的二维数组，为了方便根据menu id 查找菜单
      rawMenus: JSON.parse(sessionStorage.getItem('raw_menus')),
      account: sessionStorage.getItem('operator'),
      asideWidth: '200px',
      asideIcon: 'el-icon-arrow-left',
      // 当前激活的菜单id
      activeMenuIndex: '10000000000000000',
      // 默认展开的菜单
      defaultOpeneds: [],
      currentPosition: '控制台',
      showEditPsw: false,
      contextMenuTab: {
        index: 0,
        name: 'dashboard'
      },
      contextMenuPosition: {
        x: '0px',
        y: '0px'
      }
    }
  },
  mounted: function () {
    // 页面加载后，开始判断当前客户端用户是否一直在使用系统
    let _currentPath = this.$router.currentRoute.path
    if (_currentPath !== '/dashboard') {
      this.$router.push({
        path: '/dashboard'
      })
    }
    // 将vue对象传递进去，用于当过期时，调用退出方法
    // this.$chk.check(this)

    // 获取dom
    let tabTopDom = document.body.getElementsByClassName('el-tabs__header is-top')
    // 使用原生js 为单个dom绑定鼠标右击事件
    tabTopDom[0].oncontextmenu = this.handlerOnContextMenu

    window.onbeforeunload = function (e) {
      e = e || window.event
      // 兼容IE8和Firefox 4之前的版本
      if (e) {
        e.returnValue = '关闭提示'
      }
      // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
      return '关闭提示'
    }
    // this.currentMenus = this.menus
    // this.defaultOpeneds = [this.currentMenus[0].id]
  },
  methods: {
    handlerLogout: function () {
      let _this = this
      _this.$msgbox.confirm('确定退出系统？')
        .then(_ => {
          _this.get(_this.$apis.logout, {}, function (res) {
            let _json = res.data
            if (_json.status === 'logout') {
              _this.logout()
            }
          })
        })
        .catch(_ => {
          return false
        })
    },
    handlerMenuSelect: function (_index) {
      let _this = this
      let _currentMenu = _this.rawMenus.filter(menu => menu.id === _index)
      if (_currentMenu.length > 0) {
        let _menu = _currentMenu[0]

        if (_this.$store.state.activeTabName !== _menu.route_name) {
          // 设置权限按钮
          _this._privateHandlerSetBtns(_menu)

          _this.$store.state.activeMenuId = _menu.id
          _this.currentPosition = _menu.name
          _this.$store.state.activeTabName = _menu.route_name
        }

        let tab = {
          id: _menu.id,
          title: _menu.name,
          name: _menu.route_name,
          changedName: _menu.route_name,
          route: _menu.route_path,
          closable: true
        }
        this.$jumpInTab(tab)
      }
    },
    handlerTabClick: function (tab) {
      let _this = this
      // tab 对象是elementUI中的对象，并不是tabs数组中的元素，通过tab.index，可以获取该对象在数组中的下标
      let _index = tab.index
      // 通过下标，获取数组中对应的元素
      let _currentTab = _this.$store.state.tabs[_index]
      if (_this.$router.currentRoute.name !== _currentTab.changedName) {
        // 将点击的 tab 的id，赋值给当前被激活的menu的id
        // 通过这种方式，实现激活的菜单和激活的tab是一致的
        _this.$store.state.activeMenuId = _currentTab.id

        let _currentMenu = _this.rawMenus.filter(menu => menu.id === _currentTab.id)
        if (_currentMenu.length > 0) {
          let _menu = _currentMenu[0]
          // 设置权限按钮
          _this._privateHandlerSetBtns(_menu)
        }

        _this.currentPosition = _currentTab.title
        _this.$router.replace({
          name: _currentTab.changedName
        })
      }
      // 关闭右键菜单
      _this.$refs.contextMenu.handlerHide()
    },
    handlerTabRemove: function (_tabName) {
      let _this = this
      let _tabs = _this.$store.state.tabs
      let _activeTabName = _this.$store.state.activeTabName
      let _activeMenuId = '0'
      // 如果当前激活的tab标签的name，与要删除的标签name相同，
      // 则需要根据当前删除的标签的下标，向后或向前获取新的标签对象
      // 根据新的标签对象的路由名称，实现路由跳转
      if (_activeTabName === _tabName) {
        _tabs.forEach((tab, index) => {
          if (tab.name === _tabName) {
            let nextTab = _tabs[index + 1] || _tabs[index - 1]
            if (nextTab) {
              _activeTabName = nextTab.name
              _activeMenuId = nextTab.id
              _this.$router.replace({
                name: nextTab.changedName
              })
            }
          }
        })
      }
      _this.$store.state.tabs = _tabs.filter(tab => tab.name !== _tabName)
      if (_activeMenuId !== '0') {
        _this.$store.state.activeTabName = _activeTabName
        _this.$store.state.activeMenuId = _activeMenuId
        let _currentMenu = _this.rawMenus.filter(menu => menu.id === _activeMenuId)
        if (_currentMenu.length > 0) {
          let _menu = _currentMenu[0]
          // 设置权限按钮
          _this._privateHandlerSetBtns(_menu)
        }
      }
    },
    setAsideWidth: function () {
      this.asideWidth = this.asideWidth === '200px' ? '0px' : '200px'
      this.asideIcon = this.asideWidth === '200px' ? 'el-icon-arrow-left' : 'el-icon-arrow-right'
    },
    handlerEditPsw: function () {
      this.showEditPsw = true
    },
    handlerClose: function () {
      this.showEditPsw = false
    },
    handlerSubmit: function () {
      const _this = this
      if (_this.formData.oldPsw === '') {
        _this.$message({
          type: 'error',
          message: '旧密码不能为空'
        })
        return
      }
      if (_this.formData.newPsw === '') {
        _this.$message({
          type: 'error',
          message: '新密码不能为空'
        })
        return
      }
      if (_this.formData.newPsw !== _this.formData.confirmNewPsw) {
        _this.$message({
          type: 'error',
          message: '两次输入的新密码不同'
        })
        return
      }
      _this.post(_this.$apis.updatePsw, _this.formData, function (res) {
        const _json = res.data
        if (_json.status && _json.status === 'logout') {
          window.location.hash = '/'
        } else {
          if (_json.status === 'oldPsw_is_err') {
            _this.$message({
              type: 'error',
              message: '旧密码错误'
            })
            return
          }
          if (_json.status === 'new_psw_is_diffrent') {
            _this.$message({
              type: 'error',
              message: '两次输入的新密码不同'
            })
            return
          }
          if (_json.status === 'err') {
            _this.$message({
              type: 'error',
              message: '操作失败'
            })
          } else {
            _this.$message({
              type: 'success',
              message: '操作成功，请重新登录!'
            })
            _this.logout()
          }
        }
      })
    },
    // tab的右键菜单
    handlerOnContextMenu (e) {
      const _this = this
      // 防止默认菜单弹出
      e.preventDefault()
      // 获取当前被点击的对象
      let obj = e.srcElement ? e.srcElement : e.target
      if (obj.id) {
        // 获取到当前右键点击到的tab的name
        let currentTabName = obj.id.split('-')[1]
        let tabs = this.$store.state.tabs
        for (let i = 0; i < tabs.length; ++i) {
          if (currentTabName === tabs[i].name) {
            _this.contextMenuTab = {
              index: i,
              id: tabs[i].id,
              title: tabs[i].title,
              name: tabs[i].name,
              changedName: tabs[i].changedName,
              route: tabs[i].route
            }
            break
          }
        }
        // 右键菜单组件的位置属性
        _this.contextMenuPosition = {
          x: e.clientX + 'px',
          y: e.clientY + 'px'
        }
        // 显示右键菜单
        _this.$refs.contextMenu.handlerShow()

        obj.onblur = function () {
          // 当前右键点击的tab，失去焦点时，右键菜单自己判断，是否关闭
          _this.$refs.contextMenu.handlerCheckContextMenuStatus()
        }
      }
    },
    // 设置menu对应的列表按钮，表单按钮，编辑权限和删除权限
    _privateHandlerSetBtns: function (_menu) {
      if (_menu !== null) {
        this.$store.state.currentLBtnList = _menu.list_page_buttons
        this.$store.state.currentFBtnList = _menu.form_page_buttons
        this.$store.state.currentVBtnList = _menu.view_page_buttons
      }

      let _vBtnArr = this.$store.state.currentVBtnList
      this.$store.state.editable = (_vBtnArr.length > 0 ? _vBtnArr[0].edit_able : '否')
      this.$store.state.delable = (_vBtnArr.length > 0 ? _vBtnArr[0].delete_able : '否')
    },
    handleSetMenus: function (parentMenuId) {
      this.currentMenus = this.menus.filter((item) => {
        if (parentMenuId !== '0') {
          if (item.id === parentMenuId) {
            return item
          }
        } else {
          if (item.id !== '167284420397633536' && item.id !== '189683591620464640' && item.id !=='469952446073016320') {
            return item
          }
        }
      })
      this.defaultOpeneds = [this.currentMenus[0].id]
    }
  },
  components: {
    EzzSideMenu,
    EzzContextMenu
  }
}
</script>
